import axios from 'axios'
 
const instance = axios.create({
  //http://org1.saxmz.gov.cn/tm_website/tm_website_admin/
  // baseURL: 'https://www.sxtminfo.cn/tm_website/tm_website_admin/',
  //http://lo.vueadmin.net/tm_website_admin/
  // baseURL: 'http://lo.vueadmin.net/tm_website_admin/',
  headers: {
    'Content-Type': 'application/json',
    // 其他头部信息
  },
  timeout: 15000,
  // 其他配置项
})

export default instance